import React from 'react';
import { QuestionnaireHeader, QuestionnaireElement } from '../../../../api/jobOffers/jobOffers.dto';

export function renderQuestionnaireHeader() {
    return (element: QuestionnaireElement) => (
        <h3 key={element.id} className='font-weight-bold text-dark mb-4 mt-5'>
            {(element as QuestionnaireHeader).text}
        </h3>
    );
}
